import ContactBlock from "../components/ContactBlock";
import ContactForm from "../components/ContactForm";

export default function Contact() {
  return (
    <div className="hbe-container py-16 md:py-24" data-testid="contact-page">
      <div className="grid gap-14 md:grid-cols-2 items-start max-w-6xl">
        <div>
          <div className="hbe-eyebrow">Contact</div>
          <h1 className="mt-3 font-serif text-4xl md:text-5xl">
            Talk to a person.
          </h1>
          <p className="mt-4 text-hbe-ink/70 max-w-md">
            We reply directly. Text or call for quick questions, WhatsApp for
            longer threads, or drop a note in the form.
          </p>
          <div className="mt-8">
            <ContactBlock />
          </div>
        </div>
        <ContactForm />
      </div>
    </div>
  );
}
